// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22I8D","controls":"styles_controls__2rnxQ","charLimit":"styles_charLimit__vt-hQ","input":"styles_input__1pFRG","send":"styles_send__2Gsya"};